import { render, staticRenderFns } from "./saasLogin.vue?vue&type=template&id=5ce1285a&scoped=true&"
import script from "./saasLogin.vue?vue&type=script&lang=js&"
export * from "./saasLogin.vue?vue&type=script&lang=js&"
import style0 from "./saasLogin.vue?vue&type=style&index=0&id=5ce1285a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce1285a",
  null
  
)

export default component.exports